/**
 * Auth Types
 *
 * Types for stateless JWT authentication via BFF.
 * The JWT is encrypted and stored in an httpOnly cookie.
 *
 * All types are derived from Zod schemas in ./schemas.ts to ensure
 * consistency between TypeScript types and OpenAPI documentation.
 *
 * @see lib/auth/schemas.ts - Zod schemas (single source of truth)
 * @see lib/swagger/registry.ts - OpenAPI schema registration
 */

// Re-export all types from schemas.ts (single source of truth)
// Re-export schemas for validation use
export {
  AuthErrorSchema,
  AuthTokensSchema,
  AuthUserSchema,
  ConfirmAccountRequestSchema,
  ConfirmAccountResponseSchema,
  CookieUserSchema,
  CountrySchema,
  EncryptedTokenPayloadSchema,
  ForgotPasswordRequestSchema,
  ForgotPasswordResponseSchema,
  LoginRequestSchema,
  LoginResponseDataSchema,
  LoginResponseSchema,
  LogoutResponseSchema,
  MeResponseSchema,
  RefreshResponseSchema,
  RegisterRequestSchema,
  RegisterResponseSchema,
  ResetPasswordRequestSchema,
  ResetPasswordResponseSchema,
  UserAddressSchema,
  UserMetadataSchema,
} from './schemas';
export type {
  AuthError,
  AuthTokens,
  AuthUser,
  ConfirmAccountRequest,
  ConfirmAccountResponse,
  CookieUser,
  Country,
  EncryptedTokenPayload,
  ForgotPasswordRequest,
  ForgotPasswordResponse,
  LoginRequest,
  LoginResponse,
  LoginResponseData,
  LogoutResponse,
  MeResponse,
  RefreshResponse,
  RegisterRequest,
  RegisterResponse,
  ResetPasswordRequest,
  ResetPasswordResponse,
  UserAddress,
  UserMetadata,
} from './schemas';
